import { Store } from '@ngxs/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    ProductUnitTypeType,
    ProductUnitTypeGraphQLSchemaSelectors,
    ProductUnitTypeGraphQLSchemaActions,
    ProductUnitTypeTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import {
    Component,
    forwardRef,
    HostBinding,
    model,
    input,
    output,
    inject,
    signal,
    ViewChild,
    ElementRef
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective,
    ControlValueAccessor,
    Validator,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';
import { ZSelectComponent } from '@shared/components/form-components/z-select/z-select.component';
import { timer } from 'rxjs';

@Component({
    selector: 'z-invoice-detail-kind-select',
    imports: [ZSelectComponent, FormsModule, ReactiveFormsModule],
    templateUrl: './z-invoice-detail-kind-select.component.html',
    styleUrl: './z-invoice-detail-kind-select.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZInvoiceDetailKindSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZInvoiceDetailKindSelectComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class ZInvoiceDetailKindSelectComponent
    implements ControlValueAccessor, Validator
{
    @ViewChild('select') select?: ElementRef;
    @HostBinding('class') class?: string = 'flex flex-auto';

    mode = model<'edit' | 'view'>('view');
    label = input<string | undefined>('Κατηγορία');
    showLabel = input<boolean | undefined>();
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    options = signal<IInvoiceDetailKindType[]>([
        { _id: 'S', Title: 'Υπηρεσίες' } as IInvoiceDetailKindType,
        { _id: 'M', Title: 'Ανταλλακτικά' } as IInvoiceDetailKindType
    ]);
    placeholder = input<string | undefined>(undefined);
    onInvoiceDetailKindChange = output<IInvoiceDetailKindType | undefined>();

    store = inject(Store);

    constructor() {
        // this.store
        //     .select(ProductUnitTypeGraphQLSchemaSelectors.FetchSelector('', ''))
        //     .pipe(takeUntilDestroyed())
        //     .subscribe((value) => {
        //         if (this.options() == undefined)
        //             this.options.set(value?.data?.Fetch);
        //     });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: string): void {
        this.model = obj ?? 'M';
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
    }

    loadData() {}

    modelChange(_id: string) {
        debugger;
        this.onModelChange(_id);
        const invocieDetailKind = this.options()?.find(
            (option) => option._id == _id
        );
        if (invocieDetailKind != undefined)
            this.onInvoiceDetailKindChange.emit(invocieDetailKind);
    }

    onKeyDown($event: KeyboardEvent) {
        if ($event.code == 'NumpadEnter' || $event.code == 'Enter') {
            $event.stopPropagation();
            $event.preventDefault();

            timer(300).subscribe(() => {
                const tabKey = new KeyboardEvent('keydown', {
                    view: window,
                    code: 'Tab',
                    key: 'Tab',
                    bubbles: true,
                    cancelable: true
                });

                this.select?.nativeElement.dispatchEvent(tabKey);
            });
        }
    }
}

export interface IInvoiceDetailKindType {
    _id: 'S' | 'M';
    Title: string;
}
